import React, { useEffect, useState } from "react";
import img from "../../images/icon/Spinner-1s-200px.gif";
import "./Loading.css";
// import airports from "../../JSON/airports.json";
import $ from "jquery";
import { formateTime } from "../../common/functions";
// import loader from '../../images/loader.gif'
import loderbg from "../../images/Background.png";
import loderwithbg from "../../images/Elements.gif";
import animation from "../../images/one-way-sign.png";
import animationTwo from "../../images/Round-trip-sign.png";
import newLoader from "../../images/loader.gif";

const Loading = ({
  flag,
  loading,
  originCode,
  destinationCode,
  originCode1,
  destinationCode1,
  originCode2,
  destinationCode2,
  originCode3,
  destinationCode3,
  originCode4,
  destinationCode4,
  originCode5,
  destinationCode5,
  tripType,
}) => {
  const searchData = JSON.parse(sessionStorage.getItem("Database"));
  //   const originCode = airports
  //   .filter((f) => f.city + " - " + f.country + ", " + f.name === searchData.origin)
  //   .map((item) => item.iata);
  // const destinationCode = airports
  //   .filter((f) => f.city + " - " + f.country + ", " + f.name === searchData.destination)
  //   .map((item) => item.iata);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    let timeid;
    if (loading) {
      timeid = setInterval(() => {
        setTimer((prev) => prev + 1);
      }, 1000);
    } else {
      return () => clearInterval(timeid);
    }
  }, [loading]);

  useEffect(() => {
    if (loading) {
      $("#modal-open").click();
    } else {
      $(".modal-backdrop").remove();
      $("body").removeClass("modal-open");
      $("body").removeAttr("style");
    }
  }, [loading]);
  return (
    <div>
      <span
        data-toggle="modal"
        data-target="#staticBackdrop"
        id="modal-open"
      ></span>
      <div
        class="modal fade"
        id="staticBackdrop"
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered "
          style={{ maxWidth: "350px" }}
        >
          <div
            class="modal-content"
            style={{
              position: "relative",
              minHeight: "300px",
              backgroundColor: "transparent",
              backgroundImage: "none",
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
              boxShadow: "none",
              border: "none",
            }}
          >
            <div class="modal-body">
              <div class="text-center">
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img src={newLoader} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
